export default __webpack_public_path__ + "static/The Home_image 3@2x-4dde4257e9139f521502260a42936a6e.jpg";